import TfPandora from '@/micro-app/tf-pandora';
import { useSlideMenuCollapse } from '@/hooks/useSlideMenuCollapsedChange';
import { useTopGlobalNavCollapse } from '@/hooks/useTopGlobalNavCollapsedChange';

export default function Pandora() {
  useSlideMenuCollapse({ delay: 1000 });
  useTopGlobalNavCollapse({ delay: 1000 });
  return <TfPandora data={{ fullInjected: true }} />;
}
